// JsFromRoutes CacheKey 760b86519a6f2204916b967266d03083
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@/utils/definePathHelper'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '(/:locale)/users/sign_in'),
  create: /* #__PURE__ */ definePathHelper('post', '(/:locale)/users/sign_in'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '(/:locale)/users/sign_out'),
}
